// Banner soft amarelo cando o usuario logueado require KYC e aínda
// non está verificado. Soporta ocultalo durante a sesión.

import { ShieldAlert, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { useAuthContext } from '../../context/AuthContext';
import { useKycStatus } from '../../hooks/useKycStatus';

const STORAGE_KEY = 'chain:kycBannerDismissed';

export default function KycBanner() {
  const { user } = useAuthContext();
  const { status } = useKycStatus();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (!user) return null;
  if (!status) return null;
  if (status.status === 'VERIFIED') return null;
  if (!status.required) return null;
  if (dismissed) return null;

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3 text-sm">
        <ShieldAlert size={16} className="text-amber-700 shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="text-amber-900 font-medium">Verifica a túa identidade</span>{' '}
          <span className="text-amber-800 hidden sm:inline">
            para desbloquear todas as accións do teu rol ({status.role}).
          </span>
        </div>
        <Link
          to="/marketplace/kyc"
          className="shrink-0 px-3 py-1 rounded-lg bg-amber-700 text-white text-xs font-semibold hover:bg-amber-800 transition-colors"
        >
          Verificar
        </Link>
        <button
          onClick={handleDismiss}
          aria-label="Ocultar aviso"
          className="shrink-0 p-1 text-amber-700 hover:text-amber-900 transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
